import React from 'react';
import markdownContent from '!!raw-loader!static/accessibility.md';
import { Markdown } from 'Common';

export const AccessibilityPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};
